import { __assign, __extends } from "tslib";
import React from 'react';
import { compose } from 'redux';
import classnames from 'classnames';
import camelCase from 'lodash/camelCase';
import { withTranslation } from 'react-i18next';
import TagButton from './TagButton';
import TagsInput from './TagsInput';
import FormPopup from '../Popup/Form';
import ElementQueries from '../ElementQueries';
import TagsPopupSection from './TagsPopupSection';
import reduxConnectContainer from './TagsPopup.container';
import s from './TagsPopup.scss';
var defaultProps = {
    isOpen: false,
    contentTag: '',
    categoryTag: '',
    tags: [],
};
var enhance = compose(reduxConnectContainer, withTranslation());
var TagsPopup = /** @class */ (function (_super) {
    __extends(TagsPopup, _super);
    function TagsPopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            contentTag: _this.props.contentTag || defaultProps.contentTag,
            categoryTag: _this.props.categoryTag || defaultProps.categoryTag,
            tags: _this.props.tags || defaultProps.tags,
        };
        _this.handleSelectTag = function (e) {
            var _a;
            // Toggle the value in state
            _this.setState((_a = {},
                _a[e.target.name] = e.target.value === _this.state[e.target.name] ? '' : e.target.value,
                _a)); // TS has trouble deciphering the effective type here
        };
        _this.handleClose = function () {
            _this.props.onClose();
        };
        _this.handleSubmit = function () {
            _this.props.onSubmit(__assign({}, _this.state));
        };
        return _this;
    }
    TagsPopup.prototype.render = function () {
        var _this = this;
        var _a = this.props, t = _a.t, isOpen = _a.isOpen, contentTags = _a.contentTags, categoryTags = _a.categoryTags;
        var _b = this.state, contentTag = _b.contentTag, categoryTag = _b.categoryTag;
        return (React.createElement(FormPopup, { isOpen: isOpen, className: classnames(s['root']), title: t('tagsPopup.title'), submitBtnLabel: t('popup.confirm'), onSubmit: this.handleSubmit, onCancel: this.handleClose, onClose: this.handleClose },
            React.createElement(TagsPopupSection, { title: t('tagsPopup.content'), description: t('tagsPopup.content.description') },
                React.createElement(ElementQueries, { widthBreakpoints: [640, 800], className: s['section-container'] }, contentTags.map(function (tag, idx) { return (React.createElement(TagButton, { key: idx, name: "contentTag", value: tag, view: "b14", onClick: _this.handleSelectTag, isSelected: tag === contentTag }, t("tagsPopup.tag." + camelCase(tag)))); }))),
            React.createElement("div", { className: s['separator'] }),
            React.createElement(TagsPopupSection, { title: t('tagsPopup.category'), description: t('tagsPopup.category.description') },
                React.createElement(ElementQueries, { widthBreakpoints: [640, 800], className: s['section-container'] }, categoryTags.map(function (tag, idx) { return (React.createElement(TagButton, { key: idx, name: "categoryTag", value: tag, view: "b14", onClick: _this.handleSelectTag, isSelected: tag === categoryTag }, t("tagsPopup.tag." + camelCase(tag)))); }))),
            React.createElement("div", { className: s['separator'] }),
            React.createElement(TagsPopupSection, { title: t('tagsPopup.tags'), description: t('tagsPopup.tags.description') },
                React.createElement(TagsInput, { className: s['tag-input'] }))));
    };
    TagsPopup.prototype.renderTagPicker = function (_a) {
        var name = _a.name, description = _a.description, tags = _a.tags, selectedTag = _a.selectedTag, onClick = _a.onClick;
        var t = this.props.t;
        return (React.createElement("div", { className: s['section'] },
            React.createElement("div", { className: s['section-container'] },
                React.createElement("div", { className: s['section-name'] }, t(name)),
                React.createElement("div", { className: s['section-description'] }, t(description)))));
    };
    TagsPopup.defaultProps = defaultProps;
    return TagsPopup;
}(React.Component));
export { TagsPopup };
export default enhance(TagsPopup);
//# sourceMappingURL=TagsPopup.js.map